import React from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Button } from '@material-ui/core';
import { notificationManager } from './NotificationUtils';
import { useDispatch } from 'react-redux';
import { stepDownLoaderCount, stepUpLoaderCount } from './loaderSlice';

const ExportPageAsPDF = ({
  contentId = null,
  title = '',
  fileName = '',
  hotelName,
  showAllForReport,
  startDate,
  endDate,
  isTableReport = false,
  items = [],
  showLoader = () => {},
  setShowAllForReport = () => {},
  setShowMoreDetail = () => {},
}) => {
  const dispatch = useDispatch();

  const exportPageAsPDF = () => {
    setShowMoreDetail(false);
    showLoader(true);
    dispatch(stepUpLoaderCount());
    setShowAllForReport(true);

    setTimeout(() => {
      try {
        if (isTableReport) {
          const doc = new jsPDF('p', 'mm', 'a4');

          doc?.setFont('helvetica', 'bold');
          doc?.setFontSize(18);
          doc?.text(`${title} Report`, 105, 10, { align: 'center' });
          const headers = items?.length > 0 ? [Object.keys(items[0])] : [];
          const rows = items?.map((row) => Object.values(row));

          // Temporary purpose.
          // for (const row of items) {
          //   for (const key of Object.keys(row)) {
          //     if (Array.isArray(row[key]) && row[key]?.length > 0) {
          //       row[key]?.forEach((value, index) => {
          //         if (index === 0) {
          //           delete row[key];
          //           console.log(row);
          //           rows.push([...Object.values(row), ...[value]]);
          //         } else {
          //           rows.push(["", "", value]);
          //         }
          //       });
          //     }
          //   }
          // }

          doc.autoTable({
            startY: 20,
            head: headers,
            body: rows,
            theme: 'striped',
            styles: {
              font: 'helvetica',
              fontStyle: 'normal',
              fontSize: 12,
              textColor: [0, 0, 0],
              fillColor: [240, 243, 241],
              cellPadding: 3,
            },
            headStyles: {
              textColor: [0, 0, 0],
              fillColor: [144, 238, 144],
              fontStyle: 'bold',
              fontSize: 12,
              cellPadding: 3,
            },
            margin: 20,
            showHead: 'everyPage',
            tableWidth: 'auto',
            columnStyles: { 0: { cellWidth: 'auto' } },
          });

          doc.save(`${hotelName} ${title} Report.pdf`);
        } else {
          const input = document?.getElementById(contentId);
          if (!input) {
            notificationManager('error', 'Content not found.');
            return;
          }

          html2canvas(input, { useCORS: true }).then((canvas) => {
            const doc = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 210;
            const pageHeight = 295;

            const frameHeight = canvas?.height;
            const frameWidth = canvas?.width;

            let imgHeight = (frameHeight * imgWidth) / frameWidth + 20;
            let heightLeft = imgHeight + 20;
            let heightPosition = 25;

            doc?.setFont('helvetica', 'bold');
            doc?.setFontSize(18);
            doc?.text(`${title} Report`, imgWidth / 2, 10, { align: 'center' });
            doc?.setFontSize(10);
            doc?.setFont('helvetica', 'normal');
            doc?.setTextColor(0, 0, 0);
            doc?.text(`${hotelName}`, imgWidth / 2, 16, {
              align: 'center',
            });
            doc?.setTextColor(0, 0, 0);
            doc?.text(`${startDate} - ${endDate}`, imgWidth / 2, 22, {
              align: 'center',
            });

            doc.addImage(
              canvas?.toDataURL('image/png'),
              'PNG',
              10,
              heightPosition,
              imgWidth - 20,
              imgHeight,
            );
            heightLeft -= imgHeight;

            while (heightLeft >= 0) {
              heightPosition = heightLeft - pageHeight;
              doc?.addPage();
              doc?.addImage(
                canvas.toDataURL('image/png'),
                'PNG',
                10,
                heightPosition,
                imgWidth - 20,
                imgHeight,
              );
              heightLeft -= imgHeight;
            }

            doc?.save(`${hotelName} ${fileName} Report.pdf`);
          });
        }
      } catch (error) {
        notificationManager('error', 'An error occurred while exporting the PDF.');
      } finally {
        notificationManager('success', 'Report exported successfully.');
        setShowAllForReport(false);
        showLoader(false);
        dispatch(stepDownLoaderCount());
      }
    }, 1000);
  };

  return (
    <div className='p-0 d-flex justify-content-end align-content-center w-100 pe-2 py-2'>
      {/* info: temporarily commented out this code for hiding the export pdf button
      <Button
        color="secondary"
        variant="outlined"
        endIcon={
          <img
            className="mb-1"
            title="Report Export"
            src="./assets/icons/dashboard/export-icon.svg"
            alt="export"
          />
        }
        onClick={exportPageAsPDF}
      >
        Export
      </Button> */}
    </div>
  );
};

export default ExportPageAsPDF;
